import { render } from "./NewArrivals.vue?vue&type=template&id=46f8c2b4&scoped=true"
import script from "./NewArrivals.vue?vue&type=script&lang=js"
export * from "./NewArrivals.vue?vue&type=script&lang=js"

import "./NewArrivals.vue?vue&type=style&index=0&id=46f8c2b4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f8c2b4"]])

export default __exports__